export const tableColumnList = [
  {
    field: 'productCode', // 1
    title: '商品代码',
    width: '200',
    editRender: {
      name: 'productCode',
    },
  },
  {
    field: 'productCategary',
    title: '商品名称',
    width: '150',
    editRender: { name: 'productCategary' },
  },

  {
    field: 'unit',
    title: '单位',
    width: '140',
    editRender: {
      name: 'unit',
    },
  },
  {
    field: 'purchaseQty',
    title: '本月购进量',
    width: '140',
    editRender: {
      name: 'purchaseQty',
    },
  },
  {
    field: 'saleQty',
    title: '本月销售量',
    width: '150',
    editRender: {
      name: 'saleQty',
    },
  },

  {
    field: 'purchaseQtySum',
    title: '本年累计购进量',
    width: '140',
    editRender: {
      name: 'purchaseQtySum',
    },
  },
  {
    field: 'saleQtySum',
    title: '本年累计销售量',
    width: '150',
    editRender: {
      name: 'saleQtySum',
    },
  },

  {
    field: 'inventoryQty',
    title: '期初库存量',
    width: '160',
    editRender: { name: 'inventoryQty' },
  },
  {
    field: 'inventoryQtyEnd',
    title: '期末库存量',
    width: '160',
    editRender: { name: 'inventoryQtyEnd' },
  },

  {
    field: 'remark',
    title: '备注',
    width: '200',
    editRender: { name: 'remark' },
  },
];

export const tableRules = {
  productCategary: [{ required: true, message: '商品名称不能为空' }],
  unit: [{ required: true, message: '单位不能为空' }],
  purchaseQty: [{ required: true, message: '本期购进量不能为空' }],
  saleQty: [{ required: true, message: '本期销售量不能为空' }],
  inventoryQty: [{ required: true, message: '期初库存量不能为空' }],
};
